const WAITER_APP_PATTERN = /^\/[^/]+\/(garcom|estacao)/;

const auth = {
    getToken: () => {
        if (WAITER_APP_PATTERN.test(window.location.pathname)) {
            return localStorage.getItem('otp_token') || localStorage.getItem('token');
        }
        return localStorage.getItem('token');
    },
}

export default auth;